import axios from 'axios';
import constants from "../constants";
import {getHeaders} from './global';

function createLog(payload){
    return axios.post(
        constants.API_BASE_URL + "logs/", payload
    )
}

function isLogged() {
    let loggedIn = localStorage.getItem('jwt') || false
    if (loggedIn != false){
        loggedIn = true
    }
    return loggedIn
}

function getUser(id){
    return axios.get(
        constants.API_BASE_URL + "users/" + id + '/',
        getHeaders()
    )
}

function registerUser(payload){
    return axios.post(
        constants.API_BASE_URL + "users/signup/", payload
    )
}

function getUserPlan(user_id){
    return axios.get(
        constants.API_BASE_URL + "user-plan/" + user_id + '/',
        getHeaders()
    )
}

function updateUser(user_id, payload){
    return axios.patch(
        constants.API_BASE_URL + "users/" + user_id + '/',
        payload,
        getHeaders()
    )
}

function getUserInvitations(user_id){
    return axios.get(
        constants.API_BASE_URL + "users/" + user_id + '/invitations/',
        getHeaders()
    )
}

function acceptUserInvitation(user_id, invitation_id){
    return axios.patch(
        constants.API_BASE_URL + "users/" + user_id + '/invitations/',
        {"invitation_id": invitation_id, "type_request": "approve"},
        getHeaders()
    )
}

function dismissUserInvitation(user_id, invitation_id){
    return axios.patch(
        constants.API_BASE_URL + "users/" + user_id + '/invitations/',
        {"invitation_id": invitation_id, "type_request": "dismiss"},
        getHeaders()
    )
}

function changeUserPassword(user_id, payload){
    return axios.patch(
        constants.API_BASE_URL + "users/" + user_id + '/password/',
        payload,
        getHeaders()
    )
}

function loginUser(payload){
    return axios.post(
        constants.API_BASE_URL + "users/login/",
        payload,
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )
}

function resendVerificationLink(email){
    return axios.post(
        constants.API_BASE_URL + "confirmation-email/",
        {
            "email": email
        },
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )
}

function validateEmailAddress(token){
    return axios.post(
        constants.API_BASE_URL + "validate-email/",
        {
            "token": token
        },
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )
}

function getInitials(string) {
    var names = string.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();
    
    if (names.length > 1) {
        initials += names[1].substring(0, 1).toUpperCase();
    }
    return initials;
};


export {
    isLogged,
    getUser,
    loginUser,
    updateUser,
    getUserInvitations,
    changeUserPassword,
    resendVerificationLink,
    validateEmailAddress,
    acceptUserInvitation,
    dismissUserInvitation,
    getInitials,
    getUserPlan,
    registerUser,
    createLog,
}